module.exports = __webpack_public_path__ + "img/tech.42d8c625.png";